import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import { StoryblokRichTextNode } from '@storyblok/richtext';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MarkdownModule } from 'ngx-markdown';

import { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';
import { HeadingGroupComponent } from '@valk-nx/storyblok/components/heading-group/src/lib/heading-group';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';

@Component({
	selector: 'sb-heading-group-section',
	templateUrl: './heading-group-section.html',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		AngularSvgIconModule,
		HeadingGroupComponent,
		MarkdownModule,
		StoryblokDirective,
	],
	host: { class: 'w-full' },
})
export class HeadingGroupSectionComponent extends StoryblokRootDirective {
	@Input() topFigure = '';
	@Input() bottomFigure = '';
	@Input() overline = '';
	@Input({ required: true }) title!: StoryblokRichTextNode<string> | string;
	@Input() content = '';
	@Input({ required: true }) headingType: HeadingType = 'h2';
}
